'use client'

import DynamicFormGenerator from '@/components/organisms/dynamic-form-generator'
import CustomComponentRenderer from '@/components/organisms/custom-component-renderer'
import {
  getRenderableArticleBlocks,
  hasRenderableArticleContent,
  type ArticleBlockContent
} from '@/lib/article-content'
import MarkdownMessage from '@/views/chat/markdown-message'

export type ArticleContent = {
  type?: string
  article_id?: string
  title?: string
  body_markdown?: string
  blocks?: ArticleBlockContent[]
  message_index?: number
  message_count?: number
}

const ArticleRenderer = ({ article }: { article: ArticleContent }) => {
  if (!hasRenderableArticleContent(article)) return null

  const blocks = getRenderableArticleBlocks(article)

  return (
    <article className='space-y-3'>
      {(article.title || article.body_markdown) && (
        <div className='space-y-2'>
          {article.title && <h2 className='text-base leading-6 font-semibold'>{article.title}</h2>}
          {article.body_markdown && (
            <MarkdownMessage className='text-sm leading-7 font-medium' content={article.body_markdown} />
          )}
        </div>
      )}
      {blocks.map((block, index) => {
        if (block.type === 'markdown' && block.markdown) {
          return <MarkdownMessage key={index} className='text-sm leading-7 font-medium' content={block.markdown} />
        }

        if (block.type === 'component' && block.component_id) {
          return (
            <CustomComponentRenderer
              key={index}
              content={{ type: 'component', component_id: block.component_id, data: block.data ?? {} }}
            />
          )
        }

        if (block.type === 'form' && block.form_config) {
          return <DynamicFormGenerator key={index} data={{ ...block.form_config, type: 'show_form' }} />
        }

        return null
      })}
    </article>
  )
}

export default ArticleRenderer
